
import api from '../api';
/**
 * Fetch reward cards from the server.
 *
 * @param {string} token - Bearer authentication token.
 * @return {Promise<Array>} - A promise that resolves to an array of reward cards.
 * @throws {Error} - If the API call fails.
 */
const getRewardCards = async () => {

  try {
    // Define the API endpoint. Update this according to your API structure.
    const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/rewardCard/getRewardCards`;

    // Send GET request to the server
    const response = await api.get(endpoint);

    return response.data;

  } catch (error) {
    console.error('Error fetching reward cards:', error);
    throw error;
  }
};

export default getRewardCards;
